export default function MapView({ userlatitude, userlongitude }) {
    const mapUrl = `https://www.google.com/maps?q=${userlatitude},${userlongitude}&z=7&output=embed`;
    return (
        <iframe
            src={mapUrl}
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
    );
}